
import { defineComponent, onMounted , reactive, toRefs} from "vue";
import { useRoute } from "vue-router";
import {employeeIdApi,tourCooperationApi} from "../../../api/farmerSpace"

function stateInfo (){
  return {
    initInfo:{} as any,
    type:'' as string
  }
}

export default defineComponent({
  setup(ref) {
    const routerObj = useRoute()
    const state = reactive(stateInfo()) 
    onMounted(()=>{
      console.log(routerObj);
      state.type= routerObj.query.type as string
      if(routerObj.query.type == '0'){
        employeeIdApi(routerObj.params.id as string).then((res:any)=>{
          state.initInfo = res.data.data
        })
      }else{
        tourCooperationApi(routerObj.params.id as string).then((res:any)=>{
          console.log(res);
          state.initInfo = res.data.data
        })
      }
    })
    return {
      ...toRefs(state)
    };
  },
});
